export const SNS_LIST = ['facebook', 'twitter', 'youtube', 'instagram'];

export const SITE_LIST = [
  { title: 'Privacy Policy', path: '/' },
  { title: 'FAQ', path: '/' }
];

export const SHARE_LIST = [
  { title: '카카오톡', image: 'kakao' },
  { title: '페이스북', image: 'facebook' },
  { title: '링크복사', image: 'link' }
];

export const UNDEFINED_IMAGE = 'assets/undefined-image.svg';

export const DEFAULT_USER_IMAGE = 'assets/default-user.png';
